import axios from 'axios';
import { IcomxBridgeCommandError } from './types';

const DEFAULT_CONFIG_MESSAGE = 'Unable to load iComX chat configuration';

export function getIcomxApiErrorMessage(error: unknown, fallbackMessage: string) {
  if (axios.isAxiosError(error)) {
    const responseCode =
      typeof error.response?.data === 'object' && error.response.data
        ? (error.response.data as { code?: string }).code
        : undefined;

    switch (error.response?.status) {
      case 403:
        return 'This patient is not available in the current organization';
      case 404:
        return 'The patient or chat mapping could not be found';
      case 409:
        if (responseCode === 'ICOMX_TELECOM_STALE') {
          return 'This contact information changed. Refresh the record before opening iComX';
        }

        if (responseCode === 'ICOMX_CONTACT_USER_BACKED') {
          return 'This iComX contact is linked to a user and cannot be synchronized automatically';
        }

        return 'The iComX contact mapping is busy. Please try again';
      case 502:
        return 'iComX is temporarily unavailable';
      case 503:
        return 'iComX chat is not enabled for this tenant';
      default:
        return fallbackMessage;
    }
  }

  return fallbackMessage;
}

export function getIcomxConfigErrorMessage(error: unknown) {
  return getIcomxApiErrorMessage(error, DEFAULT_CONFIG_MESSAGE);
}

export function getIcomxBridgeErrorMessage(error: unknown) {
  const commandError = error as IcomxBridgeCommandError;

  if (commandError?.message) {
    return commandError.message;
  }

  return 'Unable to complete the iComX chat request';
}
